import { useMutation } from '../';
import { updateInvestmentMutation } from '../mutations';

export function useUpdateInvestmentMutation() {
  const { data, isLoading, mutate } = useMutation();

  const run = (variables, onFinish) => {
    mutate(updateInvestmentMutation, variables, () => {
      if (onFinish) {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
